import React from 'react';
import Select from 'react-select';
import { Input } from 'reactstrap';
import { ISelect, IDatum } from './types';
import { FieldProps } from 'formik';

// type OwnProps = FieldProps<any> & ISelect

// export const VirtualizedSelect: React.SFC<OwnProps> = ({ field: { ...fields }, form: { touched, errors, ...rest }, ...props }) => {
//   return (
//     <Input type="select" {...fields} {...props} >
//       <option value="">{props.label}</option>
//       {props.children.map((datum: IDatum, index: number) => {
//         return <option key={index} value={datum.id || datum.value}>{datum.value}</option>
//       })}
//     </Input>
//   )
// }

interface State {
  selectedOption?: IDatum
}

interface Props {
  name: string,
  children: IDatum[],
  label: string
}

type OwnProps = FieldProps<any> & Props

export const VirtualizedSelect: React.SFC<OwnProps> = ({ field, form, ...props }) => {
  const { children } = props;
  return (
    <Select
      options={children}
      name={field.name}
      value={children.find(child => child.value === field.value)}
      onChange={(option: any) => form.setFieldValue(field.name, option.value)}
      onBlur={field.onBlur}
    />

  )
}